import { Arg, Metadata } from '../../../../../utils/spds/metadata';
import Super from '../../../core/base.gjs';
import styles from './trigger.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

const METADATA = Metadata.define({
  description: 'Trigger button for split button menu',
  meta: {
    button: Arg.component({ description: 'Button component to render as trigger' }).required(),
  },
  name: 'Split Button Trigger',
});

export default class SpdsActionButtonSplitTrigger extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-action-button-split-trigger';
  classesToMapToArgs = ['disabled', 'open'];
  styles = styles;

  <template>
    <@button
      @disabled={{@disabled}}
      @fitContent={{true}}
      @size={{@size}}
      {{this.setupComponent}}
      {{this.validateArguments}}
      aria-expanded={{if @open "true" "false"}}
      aria-haspopup="menu"
      class={{this.classes}}
      ...attributes
    >
      {{svgJar "dropdown-caret" class="spds-action-button-split-trigger-caret"}}
    </@button>
  </template>
}

export const ACTION_BUTTON_SPLIT_TRIGGER_METADATA = SpdsActionButtonSplitTrigger.metadata;
